
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import MineSweeper from "./MineSweeper";

const GameDialog = ({ handleClose }) => {
  return (
    <Dialog
      open={true}
      onKeyUp={(e) => {
        if (e.key === "Enter" && !e.shiftKey) {
          handleClose();
        }
        if (e.key === "Escape") {
          handleClose();
        }
      }}
      onClose={(event, reason) => {
        if (reason !== "backdropClick") {
          handleClose();
        }
      }}
      disableEscapeKeyDown={true}
      aria-labelledby="draggable-dialog-title"
      maxWidth="xl"
    >
      <DialogContent sx={{padding: "0px !important"}}>
        <MineSweeper closeGame={() => {handleClose()}}/>
      </DialogContent>
    </Dialog>
  );
};

export default GameDialog;
